// Journeys editor and canvas, run log, journey labels shared with «Маяк». Keys are the Russian source strings.
export default {
  en: {
    'Сценарий не может возвращаться назад: шаги идут только вперёд': 'The journey cannot go back: steps only go forward',
    'Такого шага нет': 'No such step',
    'В сценарии не больше {n} шагов': 'The journey has at most {n} steps',
    ' — нельзя: шаги идут только вперёд': ' — not allowed: steps only go forward',
    ' — соедините его со сценарием': ' — connect it to the journey',
    '(последняя)': '(latest)',
    ', ежегодно': ', yearly',
    '. Перетащите на холст или нажмите — шаг встанет после выбранного': '. Drag onto the canvas or click — the step is added after the selected one',
    '. Перетащите на шаг, чтобы соединить': '. Drag onto a step to connect',
    '0 мин': '0 min',
    '{a}{o} в {at}{y}': '{a}{o} at {at}{y}',
    '{ch}: принято {a} · доставлено {b} · прочитано {r}{k}': '{ch}: accepted {a} · delivered {b} · read {r}{k}',
    '{e} · не дольше {d}': '{e} · up to {d}',
    '«Принято» — канал взял сообщение; «доставлено» и «прочитано» — только по событию канала': '“Accepted” — the channel took the message; “delivered” and “read” only come from a channel event',
    '«Принято» — провайдер взял письмо; «доставлено» — только по событию провайдера': '“Accepted” — the provider took the email; “delivered” only comes from a provider event',
    '· сервисное': '· transactional',
    'Вид': 'Type',
    'Вписать (F)': 'Fit (F)',
    'Вписать весь сценарий': 'Fit the whole journey',
    'Вход в сегмент {s}': 'Entry into segment {s}',
    'Выход': 'Exit',
    'Добавить шаг': 'Add step',
    'Дублировать': 'Duplicate',
    'Записей пока нет.': 'No entries yet.',
    'Клавиши (?)': 'Keys (?)',
    'Клавиши редактора': 'Editor keys',
    'Крупнее': 'Larger',
    'Крупнее (+)': 'Larger (+)',
    'Масштаб {p} %, нажмите для 100 %': 'Zoom {p} %, click for 100 %',
    'Масштаб холста': 'Canvas zoom',
    'Мельче': 'Smaller',
    'Мельче (−)': 'Smaller (−)',
    'Мини-карта': 'Mini-map',
    'Мини-карта сценария: перетащите рамку, чтобы сдвинуть холст': 'Journey mini-map: drag the frame to move the canvas',
    'Мышью и пальцем: тяните шаг за тело, связь — от кружка-выхода к шагу, новый шаг — из палитры на холст или на связь. Колесо — сдвиг, Ctrl+колесо или два пальца — масштаб. Всё то же можно сделать в режиме «Список шагов».': 'With a mouse or touch: drag a step by its body, a link from the exit circle to a step, a new step from the palette onto the canvas or onto a link. Wheel to pan, Ctrl+wheel or two fingers to zoom. Everything can also be done in “Step list” mode.',
    'Настройки': 'Settings',
    'Недостижим.': 'Unreachable.',
    'Нет других шагов': 'No other steps',
    'Новый шаг': 'New step',
    'Новый шаг на выходе «{p}»': 'New step on exit “{p}”',
    'Отмена': 'Cancel',
    'Отменено': 'Cancelled',
    'Отменить': 'Cancel',
    'Отменить (Ctrl+Z)': 'Undo (Ctrl+Z)',
    'Перемещение отменено': 'Move cancelled',
    'Перетащите шаг из палитры на холст или на связь от «Старта». На телефоне — кнопка «Шаг».': 'Drag a step from the palette onto the canvas or onto a link from “Start”. On a phone, use the “Step” button.',
    'Повторено': 'Redone',
    'Повторить': 'Retry',
    'Повторить (Ctrl+Shift+Z)': 'Redo (Ctrl+Shift+Z)',
    'Понятно': 'Got it',
    'Правка': 'Edit',
    'Расставить шаги заново сверху вниз': 'Lay out the steps again, top to bottom',
    'Связь {p} {a} → {b}': 'Link {p} {a} → {b}',
    'Связь {p} → {a} удалена': 'Link {p} → {a} removed',
    'Сколько раз шаг завершился': 'How many times the step completed',
    'Сначала выберите шаг-цель клавишей Tab': 'First choose the target step with Tab',
    'Событие {e}{w}': 'Event {e}{w}',
    'Соединение отменено': 'Connection cancelled',
    'Соединить…': 'Connect…',
    'Список шагов': 'Step list',
    'Старт': 'Start',
    'Старт удалить нельзя: у сценария всегда есть триггер': 'The start cannot be deleted: a journey always has a trigger',
    'Типы шагов': 'Step types',
    'Удалены в этой версии:': 'Removed in this version:',
    'Удалить': 'Delete',
    'Удалить связь': 'Delete link',
    'Удержания: пауза, тихие часы, стоп-краны': 'Holds: pause, quiet hours, stop switches',
    'Упорядочить': 'Tidy up',
    'Участия, которые сейчас на этом шаге': 'Enrollments currently on this step',
    'Холст': 'Canvas',
    'Холст сценария, прокручивается внутри рамки': 'Journey canvas, scrolls inside the frame',
    'Холст сценария, шагов: {n}. Tab — по шагам, Enter — настройки, ? — все клавиши': 'Journey canvas, steps: {n}. Tab — by step, Enter — settings, ? — all keys',
    'Шаг': 'Step',
    'Шаг {id}: {label}': 'Step {id}: {label}',
    'Шаг {n} перемещён': 'Step {n} moved',
    'Шаг {n} скопирован как {c}': 'Step {n} copied as {c}',
    'Шаг {n} удалён': 'Step {n} deleted',
    'Шаг {s} {id}: {sum}.': 'Step {s} {id}: {sum}.',
    'Шаг «{s}» вставлен в связь {p} {n}': 'Step “{s}” inserted into link {p} {n}',
    'Шаг «{s}» добавлен на холст{h}': 'Step “{s}” added to the canvas{h}',
    'Шаг «{s}» добавлен{w}': 'Step “{s}” added{w}',
    'Шаг перемещён': 'Step moved',
    'Шаг после {x}': 'Step after {x}',
    'Шаги': 'Steps',
    'Шаги расставлены автоматически': 'Steps arranged automatically',
    'в сегменте {s}': 'in segment {s}',
    'вариант': 'variant',
    'вариант {id} {w}%': 'variant {id} {w}%',
    'вариант {v}': 'variant {v}',
    'вариант {x}': 'variant {x}',
    'ветка → {x}': 'branch → {x}',
    'всегда': 'always',
    'дальше': 'next',
    'дн.': 'd.',
    'до {time}': 'until {time}',
    'до {time}{days} по времени контакта': 'until {time}{days} in the contact’s time',
    'есть событие': 'has event',
    'есть согласие': 'has consent',
    'за {d}': 'within {d}',
    'и': 'and',
    'или': 'or',
    'иначе': 'else',
    'конец': 'end',
    'конец ветки': 'end of branch',
    'контекст: {f}': 'context: {f}',
    'не': 'not',
    'недостижим': 'unreachable',
    'нет записи о согласии': 'no consent record',
    'нет переменных: {v}': 'missing variables: {v}',
    'ничего': 'nothing',
    'п.п.': 'pp',
    'письма: {label}': 'emails: {label}',
    'письмо': 'email',
    'письмо шага {m}: {s}': 'step email {m}: {s}',
    'после': 'after',
    'принято {a} · доставлено {b} · отказы {c} · жалобы {d}': 'accepted {a} · delivered {b} · bounces {c} · complaints {d}',
    'прошло': 'passed',
    'раз': 'times',
    'редактор сценария': 'journey editor',
    'сейчас': 'now',
    'событие': 'event',
    'событие ожидания: {f}': 'waited event: {f}',
    'событие пришло': 'event received',
    'согласие отозвано': 'consent withdrawn',
    'старт': 'start',
    'старта': 'start',
    'тайм-аут': 'timeout',
    'шаблон не выбран': 'no template selected',
    'эндпоинт не выбран': 'no endpoint selected',
    '→ в связь': '→ onto a link',
    'Ошибок: {n}.': 'Errors: {n}.',
    'Предупреждений: {n}.': 'Warnings: {n}.',
    'ошибки {n}': 'errors {n}',
    'удержано {n}': 'held {n}',
    'уведомлений {n} · €{c}': 'notifications {n} · €{c}',
    'исходы ({n})': 'outcomes ({n})',
    ' · пропуск {n}': ' · skipped {n}',
    'письмо поставлено в очередь': 'email queued',
    'У {n} нет выходов': '{n} has no exits',
    'Выход {p}, сейчас → {n}': 'Exit {p}, now → {n}',
    'Соединение от {f}: выход {p}. Стрелки — другой выход, Tab — шаг-цель, Enter — соединить, Esc — отмена': 'Connecting from {f}: exit {p}. Arrows — another exit, Tab — target step, Enter — connect, Esc — cancel',
    'Цель: {n}{w}. Enter — соединить': 'Target: {n}{w}. Enter — connect',
    'Настройки {n} открыты справа': 'Settings for {n} opened on the right',
    'Перемещение {n}: стрелки — на 8 px, с Shift — на 40, Enter — готово, Esc — вернуть': 'Moving {n}: arrows — 8 px, Shift — 40, Enter — done, Esc — revert',
    'Перемещение: стрелки, Shift — шагом 40 px · Enter — готово · Esc — вернуть': 'Move: arrows, Shift — 40 px steps · Enter — done · Esc — revert',
    'Соединение: ←/→ — выход · Tab — шаг-цель · Enter — соединить · Esc — отмена': 'Connect: ←/→ — exit · Tab — target step · Enter — connect · Esc — cancel',
    'условие {n}': 'condition {n}',
    'вход': 'entry',
    'шаг выполнен': 'step completed',
    'удержание': 'hold',
    'выход': 'exit',
    'миграция': 'migration',
    'шаг': 'step',
    '+{n} мин': '+{n} min',
    '+{n} ч': '+{n} h',
    '+{n} дн.': '+{n} d',
    'Телеграм-бот': 'Telegram bot',
    'Telegram-бот': 'Telegram bot',
    'Мобильный push': 'Mobile push',
    'Течёт': 'Flowing',
    'Сценарий активен: новые участники входят, шаги выполняются': 'Journey is active: new participants join, steps run',
    'Штиль': 'Calm',
    'Пауза: шаги ждут, пока сценарий не возобновят': 'Paused: steps wait until the journey resumes',
    'Остановлено': 'Stopped',
    'Остановлен навсегда: участия завершены': 'Stopped for good: enrollments ended',
    'Черновик': 'Draft',
    'Нет опубликованной версии — ничего не отправляется': 'No published version — nothing is sent',
    'Пауза': 'Pause',
    'Ждать событие': 'Wait for event',
    'Ветка': 'Branch',
    'Сплит': 'Split',
    'Письмо': 'Email',
    'Уведомление': 'Notification',
    'Вебхук': 'Webhook',
    'Обновить контакт': 'Update contact',
    'Дайджест': 'Digest',
    'Подождать срок или до местного времени контакта': 'Wait for a period or until the contact’s local time',
    'Ждать событие контакта с тайм-аутом': 'Wait for a contact event with a timeout',
    'Пойти по первому истинному условию': 'Follow the first condition that is true',
    'Разделить участников по вариантам (A/B)': 'Split enrollments across variants (A/B)',
    'Отправить письмо по закреплённой версии шаблона': 'Send an email from the pinned template version',
    'Каскад по каналам: push, Telegram, SMS, Web Push, письмо — по политике и шаблону канала': 'Cascade across channels: push, Telegram, SMS, Web Push, email — per the policy and the channel template',
    'Поставить вебхук journey.webhook вашему серверу': 'Queue a journey.webhook to your server',
    'Записать или удалить атрибуты контакта': 'Set or remove contact attributes',
    'Собрать события за окно в одно письмо': 'Collect events over a window into one email',
    'Завершить участие': 'End enrollment',
    'Событие': 'Event',
    'Вход в сегмент': 'Segment entry',
    'Дата из атрибута': 'Date from attribute',
    'Зачисление через API': 'Enrolled via API',
    'вошёл': 'entered',
    'контрольная группа': 'control group',
    'ожидание поставлено': 'wait scheduled',
    'ожидание закончилось': 'wait finished',
    'пропуск: нет адреса': 'skipped: no address',
    'пропуск: нет согласия': 'skipped: no consent',
    'пропуск: адрес в подавлениях': 'skipped: address on the suppression list',
    'пропуск: умная отправка': 'skipped: smart sending',
    'пропуск: частотный лимит': 'skipped: frequency cap',
    'пропуск: опоздание': 'skipped: too late',
    'пропуск: ни один канал не подошёл': 'skipped: no channel matched',
    'ошибка шаблона': 'template error',
    'вебхук поставлен': 'webhook queued',
    'контакт обновлён': 'contact updated',
    'дайджест собран': 'digest assembled',
    'цель достигнута': 'goal reached',
    'вышел по фильтру выхода': 'exited by exit filter',
    'шаг «Выход»': 'the “Exit” step',
    'дошёл до конца': 'reached the end',
    'контроль завершён': 'control finished',
    'сценарий остановлен': 'journey stopped',
    'контакт удалён (GDPR)': 'contact deleted (GDPR)',
    'удержан': 'held',
    'ошибка': 'error',
    'перенесён в новую версию': 'moved to a new version',
    'не вошёл': 'did not enter',
    'горизонт симуляции': 'simulation horizon',
    'не подходит': 'not eligible',
    'сценарий на паузе': 'journey paused',
    'отправка пространства приостановлена': 'workspace sending paused',
    'отправка пространства заблокирована': 'workspace sending blocked',
    'поток приостановлен': 'stream paused',
    'глобальный стоп': 'global stop',
    'тихие часы': 'quiet hours',
    'пауза сценариев платформы': 'platform journey pause',
    'цель': 'goal',
    'фильтр выхода': 'exit filter',
    'контакт удалён': 'contact deleted',
    'перенесён': 'migrated out',
    'нет согласия': 'no consent',
    'подавление': 'suppressed',
    'в пути': 'in transit',
    'вышел': 'exited',
    'не запрошено': 'not requested',
    'ждёт решения': 'awaiting decision',
    'возвращено': 'returned',
    'аннулировано': 'voided',
    'кабинет': 'dashboard',
    'шаблон': 'template',
    'день': 'day',
    'дня': 'days',
    'дней': 'days',
    'пн': 'Mon',
    'вт': 'Tue',
    'ср': 'Wed',
    'чт': 'Thu',
    'пт': 'Fri',
    'сб': 'Sat',
    'вс': 'Sun',
    'одно из': 'one of',
    'ни одно из': 'none of',
    'содержит': 'contains',
    'начинается с': 'starts with',
    'заполнено': 'filled',
    'не заполнено': 'not filled',
    'между': 'between',
    'за последние': 'in the last',
    'больше … дней назад': 'more than … days ago',
    'в ближайшие': 'in the next',
    'да': 'yes',
    'нет': 'no',
    'условие': 'condition',
    'условия': 'conditions',
    'условий': 'conditions',
    'принято': 'accepted',
    'доставлено': 'delivered',
    'отказы': 'bounces',
    'жалобы': 'complaints',
    'в очереди': 'queued',
    'не отправлено': 'not sent',
    'исход неизвестен': 'outcome unknown',
    'отменено': 'cancelled',
    'Поставлен в очередь': 'Queued',
    'перейти к следующему / предыдущему шагу (по порядку сценария)': 'go to the next / previous step (in journey order)',
    'открыть настройки шага': 'open step settings',
    'добавить шаг после выбранного': 'add a step after the selected one',
    'соединить: ←/→ — выход, Tab — шаг-цель, Enter — соединить, Esc — отмена': 'connect: ←/→ — exit, Tab — target step, Enter — connect, Esc — cancel',
    'переместить: стрелки — на 8 px, с Shift — на 40 px, Enter/Esc — готово': 'move: arrows — 8 px, with Shift — 40 px, Enter/Esc — done',
    'удалить шаг или выбранную связь': 'delete a step or the selected link',
    'дублировать шаг': 'duplicate a step',
    'отменить': 'undo',
    'повторить': 'redo',
    'крупнее / мельче / 100 % / вписать': 'larger / smaller / 100 % / fit',
    'эта справка': 'this help',
  },
  uk: {
    'Сценарий не может возвращаться назад: шаги идут только вперёд': 'Сценарій не може повертатися назад: кроки йдуть лише вперед',
    'Такого шага нет': 'Такого кроку немає',
    'В сценарии не больше {n} шагов': 'У сценарії не більше {n} кроків',
    ' — нельзя: шаги идут только вперёд': ' — неможливо: кроки йдуть лише вперед',
    ' — соедините его со сценарием': ' — з’єднайте його зі сценарієм',
    '(последняя)': '(остання)',
    ', ежегодно': ', щорічно',
    '. Перетащите на холст или нажмите — шаг встанет после выбранного': '. Перетягніть на полотно або натисніть — крок стане після вибраного',
    '. Перетащите на шаг, чтобы соединить': '. Перетягніть на крок, щоб з’єднати',
    '0 мин': '0 хв',
    '{a}{o} в {at}{y}': '{a}{o} о {at}{y}',
    '{ch}: принято {a} · доставлено {b} · прочитано {r}{k}': '{ch}: прийнято {a} · доставлено {b} · прочитано {r}{k}',
    '{e} · не дольше {d}': '{e} · не довше {d}',
    '«Принято» — канал взял сообщение; «доставлено» и «прочитано» — только по событию канала': '«Прийнято» — канал прийняв повідомлення; «доставлено» і «прочитано» — лише за подією каналу',
    '«Принято» — провайдер взял письмо; «доставлено» — только по событию провайдера': '«Прийнято» — провайдер прийняв лист; «доставлено» — лише за подією провайдера',
    '· сервисное': '· транзакційне',
    'Вид': 'Тип',
    'Вписать (F)': 'Вписати (F)',
    'Вписать весь сценарий': 'Вписати весь сценарій',
    'Вход в сегмент {s}': 'Вхід до сегмента {s}',
    'Выход': 'Вихід',
    'Добавить шаг': 'Додати крок',
    'Дублировать': 'Дублювати',
    'Записей пока нет.': 'Записів поки немає.',
    'Клавиши (?)': 'Клавіші (?)',
    'Клавиши редактора': 'Клавіші редактора',
    'Крупнее': 'Більше',
    'Крупнее (+)': 'Більше (+)',
    'Масштаб {p} %, нажмите для 100 %': 'Масштаб {p} %, натисніть для 100 %',
    'Масштаб холста': 'Масштаб полотна',
    'Мельче': 'Менше',
    'Мельче (−)': 'Менше (−)',
    'Мини-карта': 'Міні-карта',
    'Мини-карта сценария: перетащите рамку, чтобы сдвинуть холст': 'Міні-карта сценарію: перетягніть рамку, щоб зсунути полотно',
    'Мышью и пальцем: тяните шаг за тело, связь — от кружка-выхода к шагу, новый шаг — из палитры на холст или на связь. Колесо — сдвиг, Ctrl+колесо или два пальца — масштаб. Всё то же можно сделать в режиме «Список шагов».': 'Мишею і пальцем: тягніть крок за тіло, зв’язок — від кружечка-виходу до кроку, новий крок — з палітри на полотно або на зв’язок. Колесо — зсув, Ctrl+колесо або два пальці — масштаб. Усе те саме можна зробити в режимі «Список кроків».',
    'Настройки': 'Налаштування',
    'Недостижим.': 'Недосяжний.',
    'Нет других шагов': 'Немає інших кроків',
    'Новый шаг': 'Новий крок',
    'Новый шаг на выходе «{p}»': 'Новий крок на виході «{p}»',
    'Отмена': 'Скасувати',
    'Отменено': 'Скасовано',
    'Отменить': 'Скасувати',
    'Отменить (Ctrl+Z)': 'Скасувати (Ctrl+Z)',
    'Перемещение отменено': 'Переміщення скасовано',
    'Перетащите шаг из палитры на холст или на связь от «Старта». На телефоне — кнопка «Шаг».': 'Перетягніть крок з палітри на полотно або на зв’язок від «Старту». На телефоні — кнопка «Крок».',
    'Повторено': 'Повторено',
    'Повторить': 'Повторити',
    'Повторить (Ctrl+Shift+Z)': 'Повторити (Ctrl+Shift+Z)',
    'Понятно': 'Зрозуміло',
    'Правка': 'Редагування',
    'Расставить шаги заново сверху вниз': 'Розставити кроки заново згори донизу',
    'Связь {p} {a} → {b}': 'Зв’язок {p} {a} → {b}',
    'Связь {p} → {a} удалена': 'Зв’язок {p} → {a} видалено',
    'Сколько раз шаг завершился': 'Скільки разів крок завершився',
    'Сначала выберите шаг-цель клавишей Tab': 'Спершу оберіть крок-ціль клавішею Tab',
    'Событие {e}{w}': 'Подія {e}{w}',
    'Соединение отменено': 'З’єднання скасовано',
    'Соединить…': 'З’єднати…',
    'Список шагов': 'Список кроків',
    'Старт': 'Старт',
    'Старт удалить нельзя: у сценария всегда есть триггер': 'Старт не можна видалити: у сценарію завжди є тригер',
    'Типы шагов': 'Типи кроків',
    'Удалены в этой версии:': 'Видалено в цій версії:',
    'Удалить': 'Видалити',
    'Удалить связь': 'Видалити зв’язок',
    'Удержания: пауза, тихие часы, стоп-краны': 'Утримання: пауза, тихі години, стоп-крани',
    'Упорядочить': 'Упорядкувати',
    'Участия, которые сейчас на этом шаге': 'Учасники, які зараз на цьому кроці',
    'Холст': 'Полотно',
    'Холст сценария, прокручивается внутри рамки': 'Полотно сценарію, прокручується всередині рамки',
    'Холст сценария, шагов: {n}. Tab — по шагам, Enter — настройки, ? — все клавиши': 'Полотно сценарію, кроків: {n}. Tab — за кроками, Enter — налаштування, ? — усі клавіші',
    'Шаг': 'Крок',
    'Шаг {id}: {label}': 'Крок {id}: {label}',
    'Шаг {n} перемещён': 'Крок {n} переміщено',
    'Шаг {n} скопирован как {c}': 'Крок {n} скопійовано як {c}',
    'Шаг {n} удалён': 'Крок {n} видалено',
    'Шаг {s} {id}: {sum}.': 'Крок {s} {id}: {sum}.',
    'Шаг «{s}» вставлен в связь {p} {n}': 'Крок «{s}» вставлено в зв’язок {p} {n}',
    'Шаг «{s}» добавлен на холст{h}': 'Крок «{s}» додано на полотно{h}',
    'Шаг «{s}» добавлен{w}': 'Крок «{s}» додано{w}',
    'Шаг перемещён': 'Крок переміщено',
    'Шаг после {x}': 'Крок після {x}',
    'Шаги': 'Кроки',
    'Шаги расставлены автоматически': 'Кроки розставлено автоматично',
    'в сегменте {s}': 'у сегменті {s}',
    'вариант': 'варіант',
    'вариант {id} {w}%': 'варіант {id} {w}%',
    'вариант {v}': 'варіант {v}',
    'вариант {x}': 'варіант {x}',
    'ветка → {x}': 'гілка → {x}',
    'всегда': 'завжди',
    'дальше': 'далі',
    'дн.': 'дн.',
    'до {time}': 'до {time}',
    'до {time}{days} по времени контакта': 'до {time}{days} за часом контакту',
    'есть событие': 'є подія',
    'есть согласие': 'є згода',
    'за {d}': 'за {d}',
    'и': 'і',
    'или': 'або',
    'иначе': 'інакше',
    'конец': 'кінець',
    'конец ветки': 'кінець гілки',
    'контекст: {f}': 'контекст: {f}',
    'не': 'не',
    'недостижим': 'недосяжний',
    'нет записи о согласии': 'немає запису про згоду',
    'нет переменных: {v}': 'немає змінних: {v}',
    'ничего': 'нічого',
    'п.п.': 'п.п.',
    'письма: {label}': 'листи: {label}',
    'письмо': 'лист',
    'письмо шага {m}: {s}': 'лист кроку {m}: {s}',
    'после': 'після',
    'принято {a} · доставлено {b} · отказы {c} · жалобы {d}': 'прийнято {a} · доставлено {b} · відскоки {c} · скарги {d}',
    'прошло': 'пройшло',
    'раз': 'разів',
    'редактор сценария': 'редактор сценарію',
    'сейчас': 'зараз',
    'событие': 'подія',
    'событие ожидания: {f}': 'подія очікування: {f}',
    'событие пришло': 'подія надійшла',
    'согласие отозвано': 'згоду відкликано',
    'старт': 'старт',
    'старта': 'старту',
    'тайм-аут': 'тайм-аут',
    'шаблон не выбран': 'шаблон не вибрано',
    'эндпоинт не выбран': 'ендпоінт не вибрано',
    '→ в связь': '→ на зв’язок',
    'Ошибок: {n}.': 'Помилок: {n}.',
    'Предупреждений: {n}.': 'Попереджень: {n}.',
    'ошибки {n}': 'помилки {n}',
    'удержано {n}': 'утримано {n}',
    'уведомлений {n} · €{c}': 'сповіщень {n} · €{c}',
    'исходы ({n})': 'результати ({n})',
    ' · пропуск {n}': ' · пропуск {n}',
    'письмо поставлено в очередь': 'лист поставлено в чергу',
    'У {n} нет выходов': 'У {n} немає виходів',
    'Выход {p}, сейчас → {n}': 'Вихід {p}, зараз → {n}',
    'Соединение от {f}: выход {p}. Стрелки — другой выход, Tab — шаг-цель, Enter — соединить, Esc — отмена': 'З’єднання від {f}: вихід {p}. Стрілки — інший вихід, Tab — крок-ціль, Enter — з’єднати, Esc — скасувати',
    'Цель: {n}{w}. Enter — соединить': 'Ціль: {n}{w}. Enter — з’єднати',
    'Настройки {n} открыты справа': 'Налаштування {n} відкрито праворуч',
    'Перемещение {n}: стрелки — на 8 px, с Shift — на 40, Enter — готово, Esc — вернуть': 'Переміщення {n}: стрілки — на 8 px, з Shift — на 40, Enter — готово, Esc — повернути',
    'Перемещение: стрелки, Shift — шагом 40 px · Enter — готово · Esc — вернуть': 'Переміщення: стрілки, Shift — кроком 40 px · Enter — готово · Esc — повернути',
    'Соединение: ←/→ — выход · Tab — шаг-цель · Enter — соединить · Esc — отмена': 'З’єднання: ←/→ — вихід · Tab — крок-ціль · Enter — з’єднати · Esc — скасувати',
    'условие {n}': 'умова {n}',
    'вход': 'вхід',
    'шаг выполнен': 'крок виконано',
    'удержание': 'утримання',
    'выход': 'вихід',
    'миграция': 'міграція',
    'шаг': 'крок',
    '+{n} мин': '+{n} хв',
    '+{n} ч': '+{n} год',
    '+{n} дн.': '+{n} дн.',
    'Телеграм-бот': 'Telegram-бот',
    'Telegram-бот': 'Telegram-бот',
    'Мобильный push': 'Мобільний push',
    'Течёт': 'Тече',
    'Сценарий активен: новые участники входят, шаги выполняются': 'Сценарій активний: нові учасники входять, кроки виконуються',
    'Штиль': 'Штиль',
    'Пауза: шаги ждут, пока сценарий не возобновят': 'Пауза: кроки чекають, доки сценарій не відновлять',
    'Остановлено': 'Зупинено',
    'Остановлен навсегда: участия завершены': 'Зупинено назавжди: участь завершено',
    'Черновик': 'Чернетка',
    'Нет опубликованной версии — ничего не отправляется': 'Немає опублікованої версії — нічого не надсилається',
    'Пауза': 'Пауза',
    'Ждать событие': 'Чекати подію',
    'Ветка': 'Гілка',
    'Сплит': 'Розподіл',
    'Письмо': 'Лист',
    'Уведомление': 'Сповіщення',
    'Вебхук': 'Вебхук',
    'Обновить контакт': 'Оновити контакт',
    'Дайджест': 'Дайджест',
    'Подождать срок или до местного времени контакта': 'Чекати строк або до місцевого часу контакту',
    'Ждать событие контакта с тайм-аутом': 'Чекати подію контакту з тайм-аутом',
    'Пойти по первому истинному условию': 'Піти за першою істинною умовою',
    'Разделить участников по вариантам (A/B)': 'Розподілити учасників за варіантами (A/B)',
    'Отправить письмо по закреплённой версии шаблона': 'Надіслати лист за закріпленою версією шаблону',
    'Каскад по каналам: push, Telegram, SMS, Web Push, письмо — по политике и шаблону канала': 'Каскад за каналами: push, Telegram, SMS, Web Push, лист — за політикою та шаблоном каналу',
    'Поставить вебхук journey.webhook вашему серверу': 'Поставити вебхук journey.webhook на ваш сервер',
    'Записать или удалить атрибуты контакта': 'Записати або видалити атрибути контакту',
    'Собрать события за окно в одно письмо': 'Зібрати події за вікно в один лист',
    'Завершить участие': 'Завершити участь',
    'Событие': 'Подія',
    'Вход в сегмент': 'Вхід до сегмента',
    'Дата из атрибута': 'Дата з атрибута',
    'Зачисление через API': 'Зарахування через API',
    'вошёл': 'увійшов',
    'контрольная группа': 'контрольна група',
    'ожидание поставлено': 'очікування поставлено',
    'ожидание закончилось': 'очікування завершилось',
    'пропуск: нет адреса': 'пропуск: немає адреси',
    'пропуск: нет согласия': 'пропуск: немає згоди',
    'пропуск: адрес в подавлениях': 'пропуск: адреса в списку придушення',
    'пропуск: умная отправка': 'пропуск: розумне надсилання',
    'пропуск: частотный лимит': 'пропуск: частотний ліміт',
    'пропуск: опоздание': 'пропуск: запізнення',
    'пропуск: ни один канал не подошёл': 'пропуск: жоден канал не підійшов',
    'ошибка шаблона': 'помилка шаблону',
    'вебхук поставлен': 'вебхук поставлено',
    'контакт обновлён': 'контакт оновлено',
    'дайджест собран': 'дайджест зібрано',
    'цель достигнута': 'ціль досягнуто',
    'вышел по фильтру выхода': 'вийшов за фільтром виходу',
    'шаг «Выход»': 'крок «Вихід»',
    'дошёл до конца': 'дійшов до кінця',
    'контроль завершён': 'контроль завершено',
    'сценарий остановлен': 'сценарій зупинено',
    'контакт удалён (GDPR)': 'контакт видалено (GDPR)',
    'удержан': 'утримано',
    'ошибка': 'помилка',
    'перенесён в новую версию': 'перенесено до нової версії',
    'не вошёл': 'не увійшов',
    'горизонт симуляции': 'горизонт симуляції',
    'не подходит': 'не підходить',
    'сценарий на паузе': 'сценарій на паузі',
    'отправка пространства приостановлена': 'надсилання простору призупинено',
    'отправка пространства заблокирована': 'надсилання простору заблоковано',
    'поток приостановлен': 'потік призупинено',
    'глобальный стоп': 'глобальна зупинка',
    'тихие часы': 'тихі години',
    'пауза сценариев платформы': 'пауза сценаріїв платформи',
    'цель': 'ціль',
    'фильтр выхода': 'фільтр виходу',
    'контакт удалён': 'контакт видалено',
    'перенесён': 'перенесено',
    'нет согласия': 'немає згоди',
    'подавление': 'придушення',
    'в пути': 'у дорозі',
    'вышел': 'вийшов',
    'не запрошено': 'не запитано',
    'ждёт решения': 'очікує рішення',
    'возвращено': 'повернуто',
    'аннулировано': 'анульовано',
    'кабинет': 'кабінет',
    'шаблон': 'шаблон',
    'день': 'день',
    'дня': 'дні',
    'дней': 'днів',
    'пн': 'пн',
    'вт': 'вт',
    'ср': 'ср',
    'чт': 'чт',
    'пт': 'пт',
    'сб': 'сб',
    'вс': 'нд',
    'одно из': 'одне з',
    'ни одно из': 'жодне з',
    'содержит': 'містить',
    'начинается с': 'починається з',
    'заполнено': 'заповнено',
    'не заполнено': 'не заповнено',
    'между': 'між',
    'за последние': 'за останні',
    'больше … дней назад': 'більше … днів тому',
    'в ближайшие': 'найближчі',
    'да': 'так',
    'нет': 'ні',
    'условие': 'умова',
    'условия': 'умови',
    'условий': 'умов',
    'принято': 'прийнято',
    'доставлено': 'доставлено',
    'отказы': 'відскоки',
    'жалобы': 'скарги',
    'в очереди': 'у черзі',
    'не отправлено': 'не надіслано',
    'исход неизвестен': 'результат невідомий',
    'отменено': 'скасовано',
    'Поставлен в очередь': 'Поставлено в чергу',
    'перейти к следующему / предыдущему шагу (по порядку сценария)': 'перейти до наступного / попереднього кроку (за порядком сценарію)',
    'открыть настройки шага': 'відкрити налаштування кроку',
    'добавить шаг после выбранного': 'додати крок після вибраного',
    'соединить: ←/→ — выход, Tab — шаг-цель, Enter — соединить, Esc — отмена': 'з’єднати: ←/→ — вихід, Tab — крок-ціль, Enter — з’єднати, Esc — скасувати',
    'переместить: стрелки — на 8 px, с Shift — на 40 px, Enter/Esc — готово': 'перемістити: стрілки — на 8 px, з Shift — на 40 px, Enter/Esc — готово',
    'удалить шаг или выбранную связь': 'видалити крок або вибраний зв’язок',
    'дублировать шаг': 'дублювати крок',
    'отменить': 'скасувати',
    'повторить': 'повторити',
    'крупнее / мельче / 100 % / вписать': 'більше / менше / 100 % / вписати',
    'эта справка': 'ця довідка',
  },
};
